import serviceNotAvailableController from './service-not-available-controller';

export default function (app) {
	app.component('serviceNotAvailable', {
		transclude: true,
		bindings: {
			serviceNotAvailable: '='
		},
		templateUrl: function ($element, $attrs) {
			let templateName;

			switch ($attrs.template) {
				case 'onboarding':
					templateName = 'common/service-not-available';
			}

			return templateName;
		},
		controller: [serviceNotAvailableController]
	});
}
